export default __webpack_public_path__ + "static/media/feasibility.9330e232.svg";